export default {
  // Header
  header: {
    title: 'BIDV Secure Prepaid Card',
    welcome: 'Chào mừng',
    logout: 'Đăng xuất',
    language: 'Ngôn ngữ',
    profile: 'Hồ sơ',
    menu: 'Menu'
  },

  // Navigation
  nav: {
    dashboard: 'Bảng điều khiển',
    cardInfo: 'Thông tin thẻ',
    activateCard: 'Kích hoạt thẻ',
    changePin: 'Đổi mã PIN',
    lockUnlock: 'Khóa/Mở khóa thẻ',
    transactions: 'Lịch sử giao dịch',
    reports: 'Báo cáo truy cập',
    features: 'Quản lý tính năng'
  },

  // Common
  common: {
    save: 'Lưu',
    cancel: 'Hủy',
    edit: 'Sửa',
    delete: 'Xóa',
    confirm: 'Xác nhận',
    back: 'Quay lại',
    next: 'Tiếp theo',
    previous: 'Trước',
    search: 'Tìm kiếm',
    filter: 'Lọc',
    refresh: 'Làm mới',
    loading: 'Đang tải...',
    noData: 'Không có dữ liệu',
    error: 'Lỗi',
    success: 'Thành công',
    warning: 'Cảnh báo',
    info: 'Thông tin',
    current: 'Hiện tại',
    featureUnavailable: 'Tính năng tạm thời không khả dụng',
    technicalSupport: 'Hỗ trợ kỹ thuật',
    processing: 'Đang xử lý...',
    reset: 'Làm mới',
    retry: 'Thử lại'
  },

  // Error Codes
  errorCodes: {
    E101: 'Trạng thái thẻ không hợp lệ',
    E102: 'Thông tin thẻ không hợp lệ',
    E103: 'Sản phẩm thẻ không hợp lệ',
    E104: 'Xác thực đã hết hạn. Vui lòng thực hiện lại',
    E105: 'Thẻ đã hết hạn',
    E106: 'Không tìm thấy kết quả',
    E107: 'Token đã hết hạn',
    E108: 'Token không hợp lệ',
    E109: 'Tài khoản thẻ không hợp lệ',
    E110: 'Trạng thái thẻ không hợp lệ',
    E111: 'Trạng thái production không hợp lệ',
    7006: 'Không có giao dịch trong khoảng thời gian tìm kiếm',
    LockCardFailed: 'Khóa thẻ thất bại',
    UnlockCardFailed: 'Mở khóa thẻ thất bại'
  },

  // Authentication
  auth: {
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    usernamePlaceholder: 'Nhập tên đăng nhập',
    passwordPlaceholder: 'Nhập mật khẩu',
    forgotPassword: 'Quên mật khẩu?',
    loginFailed: 'Đăng nhập thất bại',
    invalidCredentials: 'Thông tin đăng nhập không hợp lệ',
    sessionExpired: 'Phiên làm việc đã hết hạn',
    captcha: 'Mã xác thực',
    captchaRefresh: 'Click để làm mới mã xác thực',
    captchaInput: 'Nhập mã xác thực',
    captchaHelper: 'Nhập 6 ký tự từ hình ảnh trên',
    captchaPlaceholder: 'Nhập mã từ hình ảnh',
    captchaRequired: 'Vui lòng xác thực captcha',
    cardId: 'Card ID',
    expiryDate: 'Ngày hết hạn (MMYY)',
    iframeError: 'Lỗi tải iframe',
    loadingLoginForm: 'Đang tải form đăng nhập...'
  },

  // Dashboard
  dashboard: {
    cardStatus: 'Trạng thái thẻ',
    balance: 'Số dư',
    currentBalance: 'Số dư hiện tại',
    availableLimit: 'Số dư khả dụng',
    recentTransactions: 'Giao dịch gần đây',
    quickActions: 'Thao tác nhanh',
    systemStatus: 'Trạng thái hệ thống'
  },

  // Card Management
  card: {
    lockCardSuccess: 'Khóa thẻ thành công',
    unlockCardSuccess: 'Mở khóa thẻ thành công',
    lockCardPending: 'Đang khóa thẻ',
    unlockCardPending: 'Đang mở khóa thẻ',
    lockCard: 'Khóa thẻ',
    unlockCard: 'Mở khóa thẻ',
    titleCardInfo: 'Thông tin thẻ',
    cardNumber: 'Số thẻ',
    cardId: 'Card ID',
    cardHolder: 'Chủ thẻ',
    expiryDate: 'Ngày hết hạn',
    cvv: 'Mã CVV',
    pin: 'Mã PIN',
    status: 'Trạng thái',
    balance: 'Số dư',
    dailyLimit: 'Hạn mức hàng ngày',
    monthlyLimit: 'Hạn mức hàng tháng',
    activate: 'Kích hoạt',
    deactivate: 'Vô hiệu hóa',
    lock: 'Khóa thẻ',
    unlock: 'Mở khóa thẻ',
    changePin: 'Đổi mã PIN',
    currentPin: 'Mã PIN hiện tại',
    newPin: 'Mã PIN mới',
    confirmPin: 'Xác nhận mã PIN',
    productType: 'Loại sản phẩm thẻ',
    lockUnlockMaintenanceMessage: 'Tính năng khóa/mở khóa thẻ đang được bảo trì. Vui lòng thử lại sau.',
    // New keys for CardInfo component
    basicInfo: 'Thông tin cơ bản',
    cardStatus: 'Trạng thái thẻ',
    financialInfo: 'Thông tin tài chính',
    timeInfo: 'Thông tin thời gian',
    currentBalance: 'Số dư hiện tại',
    blockedAmount: 'Số dư phong tỏa',
    availableLimit: 'Số dư khả dụng',
    embossingName: 'Tên in trên thẻ',
    contractBranch: 'Chi nhánh phát hành',
    productionStatus: 'Trạng thái sản xuất',
    activationStatus: 'Trạng thái kích hoạt',
    activated: 'Đã kích hoạt',
    notActivated: 'Chưa kích hoạt',
    cvv2: 'Số CVV2',
    issueDate: 'Ngày phát hành',
    cardDetails: 'Thông tin chi tiết thẻ',
    // viewCardDetails: 'Xem thông tin chi tiết về thẻ prepaid của bạn',
    securityNotice: 'Lưu ý',
    securityNoticeDescription: 'Quý khách vui lòng bảo mật thông tin thẻ. Việc lộ thông tin thẻ có thể dẫn đến rủi ro mất tiền.',

    visaPrepaidNonKYC: 'Visa Prepaid Non-KYC',
    napasPrepaidNonKYC: 'NAPAS Prepaid Non-KYC',
    // New keys for ChangePin component
    changePinTitle: 'Đặt/Đổi PIN',
    changePinDescription: 'Thay đổi mã PIN để bảo mật thẻ của bạn',
    cardInfoTitle: 'Thông tin thẻ',
    cardNumberLabel: 'Số thẻ',
    cardStatusLabel: 'Trạng thái thẻ',
    productionStatusLabel: 'Trạng thái kích hoạt',
    expiryDateLabel: 'Ngày hết hạn',
    newPinInfoTitle: 'Thông tin PIN mới',
    newPinLabel: 'Mã PIN mới',
    newPinHelperText: 'Nhập 6 chữ số PIN mới',
    newPinPlaceholder: '000000',
    confirmPinLabel: 'Nhập lại mã PIN mới',
    confirmPinHelperText: 'Nhập lại PIN mới để xác nhận',
    confirmPinPlaceholder: '000000',
    changePinButton: 'Đổi PIN',
    changePinWarningTitle: 'Lưu ý khi đổi PIN',
    changePinWarningDescription: '• PIN phải có đúng 6 ký tự số',
    changePinWarningDescription2: '• Quý khách lưu ý bảo mật và không tiết lộ mã PIN cho bất kỳ ai',
    // New keys for LockUnlockCard component
    lockUnlockTitle: 'Khóa/Mở khóa thẻ',
    lockUnlockDescription: 'Quản lý trạng thái hoạt động của thẻ',
    confirmLockTitle: 'Xác nhận khóa thẻ',
    confirmLockContent: 'Bạn có chắc chắn muốn khóa thẻ? Thẻ sẽ không thể sử dụng cho đến khi được mở khóa.',
    confirmUnlockTitle: 'Xác nhận mở khóa thẻ',
    confirmUnlockContent: 'Bạn có chắc chắn muốn mở khóa thẻ? Thẻ sẽ có thể sử dụng bình thường.',
    // New keys for ActivateCard component
    activateCardTitle: 'Kích hoạt thẻ',
    activateCardInfo: 'Nhấn nút bên dưới để kích hoạt thẻ của bạn',
    // New keys for LockUnlockCard component
    cardOperationsTitle: 'Khóa/Mở khóa thẻ',
    lockUnlockWarningTitle: 'Lưu ý quan trọng',
    lockUnlockWarningDescription: '• Khóa thẻ khi bị mất, bị đánh cắp hoặc nghi ngờ có vấn đề bảo mật\n• Mở khóa thẻ khi đã tìm lại hoặc xác nhận không có vấn đề bảo mật\n• Thẻ bị khóa sẽ không thể thực hiện bất kỳ giao dịch nào\n• Hỗ trợ khẩn cấp: 1900 9247',
    // Confirm dialog texts
    confirmLockTitleShort: 'Khóa thẻ',
    confirmUnlockTitleShort: 'Mở khóa thẻ',
    confirmLockMessageWithCard: 'Bạn có chắc chắn muốn khóa thẻ {{cardNumber}}?',
    confirmUnlockMessageWithCard: 'Bạn có chắc chắn muốn mở khóa thẻ {{cardNumber}}?'
  },

  // Transactions
  transactions: {
    titleItem: 'Tra cứu lịch sử giao dịch',
    title: 'Lịch sử giao dịch',
    date: 'Ngày',
    time: 'Thời gian',
    amount: 'Số tiền giao dịch gốc',
    amountVND: 'Số tiền giao dịch (VND)',
    type: 'Loại giao dịch',
    merchant: 'Người bán',
    location: 'Địa điểm',
    status: 'Trạng thái',
    reference: 'Mã tham chiếu',
    description: 'Mô tả',
    balance: 'Số dư sau giao dịch',
    filterByDate: 'Lọc theo ngày',
    filterByType: 'Lọc theo loại',
    filterByAmount: 'Lọc theo số tiền',
    export: 'Xuất dữ liệu',
    maintenanceMessage: 'Tính năng tra cứu lịch sử giao dịch đang được bảo trì. Vui lòng thử lại sau.',
    // New keys for TransactionHistory component
    error: {
      selectTimeRange: 'Vui lòng chọn khoảng thời gian',
      startDateGreaterThanEndDate: 'Ngày bắt đầu không được lớn hơn ngày kết thúc',
      maxTimeRange: 'Khoảng thời gian tối đa là 30 ngày',
      startDateGreaterThan12Months: 'Thời gian cho phép truy vấn tối đa là 12 tháng tính từ ngày thực hiện giao dịch.'
    },
    noDataFound: 'Không có dữ liệu giao dịch trong khoảng thời gian đã chọn',
    systemTemporarilyUnavailable: 'Hệ thống đang tạm thời gián đoạn, vui lòng thực hiện lại sau.',
    // Additional keys for complete translation
    selectTimeRange: 'Chọn khoảng thời gian giao dịch:',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    search: 'Tra cứu',
    searching: 'Đang tìm kiếm...',
    reset: 'Làm mới',
    searchResults: 'Kết quả tìm kiếm ({{count}} giao dịch)',
    transactionTime: 'Thời gian GD',
    cardNumber: 'Số thẻ',
    vndAmount: 'Số dư thẻ',
    fee: 'Phí',
    transactionCode: 'Mã GD',
    postingDate: 'Quyết toán',
    authCode: 'Số chuẩn chi',
    note: 'Lưu ý: Tìm kiếm theo tất cả các loại giao dịch của thẻ trong vòng 30 ngày gần nhất',
    endOfResults: 'Đã hiển thị tất cả giao dịch',
    loaded: 'giao dịch đã tải',
    pleaseSelectTimeRangeAndSearch: 'Vui lòng chọn khoảng thời gian và nhấn "Tìm kiếm" để xem lịch sử giao dịch'
  },


  // Messages
  messages: {
    cardActivated: 'Thẻ đã được kích hoạt thành công',
    cardDeactivated: 'Thẻ đã được vô hiệu hóa',
    pinChanged: 'Mã PIN đã được thay đổi thành công',
    cardLocked: 'Thẻ đã được khóa',
    cardUnlocked: 'Thẻ đã được mở khóa',
    operationSuccess: 'Thao tác thành công',
    operationFailed: 'Thao tác thất bại',
    confirmDelete: 'Bạn có chắc chắn muốn xóa?',
    confirmAction: 'Bạn có chắc chắn muốn thực hiện thao tác này?',
    unsavedChanges: 'Bạn có thay đổi chưa lưu. Bạn có muốn rời khỏi trang?'
  },

  // Status
  status: {
    active: 'Hoạt động',
    inactive: 'Không hoạt động',
    locked: 'Đã khóa',
    unlocked: 'Đã mở khóa',
    pending: 'Đang chờ',
    completed: 'Hoàn thành',
    failed: 'Thất bại',
    cancelled: 'Đã hủy',
    processing: 'Đang xử lý'
  },

  // Validation
  validation: {
    required: 'Trường này là bắt buộc',
    invalidFormat: 'Định dạng không hợp lệ',
    invalidPin: 'PIN phải có 6 chữ số',
    pinMismatch: 'PIN không khớp',
    minLength: 'Độ dài tối thiểu là {min} ký tự',
    maxLength: 'Độ dài tối đa là {max} ký tự',
    email: 'Định dạng email không hợp lệ',
    phone: 'Định dạng số điện thoại không hợp lệ',
    captchaRequired: 'Vui lòng xác thực captcha'
  },


};
